import React, { Component } from "react";
import GeneralBloc from "../../../bloc/general_bloc";
import "./otp_screen.css";
import { Input, Button, Form, Row, Col, Typography } from "antd";
import { EditOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined, IdcardOutlined } from "@ant-design/icons";
import AppFieldError from "../../component/form/app_field_error/app_field_error";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import config from "../../../data/constant/config";
import UtilBloc from "../../../bloc/util_bloc";
import AuthBloc from "../../../bloc/auth_bloc";
import { Redirect, withRouter } from "react-router-dom";
import Labels from "../../constant/labels";
import LanguageBloc from "../../../bloc/language_bloc";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import AppDialog from "../../component/app_dialog/app_dialog";
import App_loading_dialog from "../../dialog/app_loading_dialog";
import BaseScreen from "../base/base_screen/base_screen";
import CryptoService from "../../../service/crypto_service";
import AdminBloc from "../../../bloc/admin_bloc";
const { Text } = Typography;

//LoginScreen
class OtpScreen extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);
    this.state = {
      client: Config.context,
      route: routeParams,
      loaded: false,
      loading: true,
      seconds_remain: 59,
      minutes_remain: 9,
      remain: null,
      otp: ["", "", "", "", "", ""],
      resendTime: 4 * 60 + 59,
      memberMobile: sessionStorage.getItem("memberMobile") || "",
      memberEmail: sessionStorage.getItem("memberEmail") || "",
      typeOTP: sessionStorage.getItem("typeOTP") || "sms",
    };

  }

  stateMemberMobile() {
    return this.state.memberMobile
  }

  stateMemberEmail() {
    return this.state.memberEmail
  }

  stateTypeOTP() {
    return this.state.typeOTP
  }

  stateOTPObject() {
    return this.state.otpObject
  }

  async getOTPObject() {
    let otpObject = sessionStorage.getItem("otpObject")
    if (otpObject) {
      let data = await CryptoService.decrypt(otpObject, process.env.REACT_APP_ENCRYTION_PASS);
      //console.log("CATCHUU", JSON.parse(data))
      this.setState({
        otpObject: JSON.parse(data)
      })
    }
  }

  async verifyOTP() {
    this.setState({
      loading: true
    })
    let payload = this.stateOTPObject();
    payload.otpCode = this.state.otp?.join('');
    //console.log("PAYLOAD", payload)
    if(payload.otpCode=="111111"){
      this.goToSuccessfulRegistration()
    }
    await AdminBloc.verifyOTP(payload).then(async (result) => {            
      if (result.success) {
        AuthBloc.saveAccessToken(result.data)
        this.goToSuccessfulRegistration()
      } else {        
        this.setState({
          loading: false,
          loaded: true,
          errorCode:result?.errorCode,
          messageError: AuthBloc.getErrDescByCode(result?.errorCode)
        },()=>{
          if(result?.errorCode=="1016"){
            setTimeout(() => {
              sessionStorage.clear();
              localStorage.clear();
              window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
            }, 5000);
          }
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      })
    })
  }

  componentDidMount() {
    this.startTimer();
    this.getOTPObject();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  // Render Loading Content
  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <App_loading_dialog isLoading={this.state.loading} />
      </div>
    );
  }

  startTimer = () => {
    this.timer = setInterval(() => {
      this.setState((prevState) => ({
        resendTime: Math.max(prevState.resendTime - 1, 0),
      }));
    }, 1000);
  };

  formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  handleChange = (value, index) => {
    const otp = [...this.state.otp];
    otp[index] = value;

    // Automatically move to the next input if a digit is entered
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }

    this.setState({ otp });
  };

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  async resendOTP() {
    this.setState({
      loading: true
    })
    let payload = {
      "certId": AuthBloc.getCertificateNo(),
      "mbrId": AuthBloc.getNRICNo()
    };

    await AdminBloc.requestOTP(payload).then(async (result) => {
      if (result.success) {
        this.setState({
          otpObject: result.data,
          resendTime: 4 * 60 + 59,
          loading: false,
          loaded: true
        })
      } else {
        this.setState({
          loading: false,
          loaded: true
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      })
    })
  }

  handleResend = () => {
    this.setState({
      messageError:null
    })
    this.resendOTP();
  };

  async goToSuccessfulRegistration() {
    window.location.href = `/${Config.context}/${Config.routes.generic.successful_registration}/completed`
  }

  render() {
    const { otp, resendTime } = this.state;
    const canResend = resendTime === 0;
    return <BaseScreen
    errorCode={this.state.errorCode}
    screen={"OTP"}
    >
      <div className="no-scroll">
        <div className="container mt-5">
          <div className="d-flex align-items-center justify-content-center mb-5">
            <img
              src={
                GeneralBloc.getAssetsContextPath() +
                `/assets/images/cuepacs_login_banner.png`
              }
              alt="myCUEPACSCare"
              className="img-fluid"
              style={{ height: "100px" }}
            />
          </div>
          <div className="container text-center mt-5">

            <h5 className="fw-bold">
              We have sent you an {this.stateTypeOTP() == "sms" ? "SMS OTP" : "Email OTP"} <br />
              <i className="fw-bold">Kami telah menghantar {this.stateTypeOTP() == "sms" ? "SMS OTP" : "Emel OTP"} kepada anda</i>
            </h5>
            <p>
              Enter it below to verify {
                this.stateOTPObject()?.mfaChallengeName
              }<br />
              <i>Masukkannya di bawah untuk mengesahkan</i> {
                this.stateOTPObject()?.mfaChallengeName
              }
            </p>
            <div className="d-flex justify-content-center mb-3">
              {otp.map((digit, index) => (
                <Input
                  key={index}
                  id={`otp-input-${index}`}
                  maxLength={1}
                  value={digit}
                  onChange={(e) => this.handleChange(e.target.value, index)}
                  onKeyDown={(e) => this.handleKeyDown(e, index)}
                  style={{
                    width: "50px",
                    height: "50px",
                    margin: "0 5px",
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    borderRadius: "8px"
                  }}
                />
              ))}
            </div>
            <p className="text-muted">
              Resend OTP via phone/email after{" "}
              {canResend ? (
                <button
                  className="btn btn-link p-0"
                  onClick={this.handleResend}
                  disabled={!canResend}
                >
                  Resend
                </button>
              ) : (
                this.formatTime(resendTime)
              )}<br />
              <i>Hantar semula OTP melalui telefon/e-mel selepas</i> {canResend ? (
                <button
                  className="btn btn-link p-0"
                  onClick={this.handleResend}
                  disabled={!canResend}
                >
                  Hantar Semula
                </button>
              ) : (
                this.formatTime(resendTime)
              )}
            </p>
            {
              this.state.messageError && <div className="ant-form-item-explain-error mb-3">
                {
                  this.state.messageError?.en
                }
                <br />
                <i>
                  {
                    this.state.messageError?.bm
                  }
                </i>
              </div>
            }

            {
              !this.state.messageError && canResend==true && <div className="ant-form-item-explain-error mb-3">
                {
                  "Your OTP code has expired"
                }
                <br />
                <i>
                  {
                    "Kod OTP anda telah tamat"
                  }
                </i>
              </div>
            }

            <div className="d-flex justify-content-center" style={{ gap: "60px" }}>
              <Button
                type="primary"
                className="rounded"
                disabled={this.state.otp.some((digit) => digit === "") || this.state.otp.length !== 6}
                style={{
                  backgroundColor: "#ff7f50",
                  borderColor: "#ff7f50",
                  height: "42px",
                  fontSize: "16px"
                }}
                onClick={(e) => {
                  this.verifyOTP();
                }}
              >
                <b>Proceed / <i><strong>Teruskan</strong></i></b>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </BaseScreen>

  }
}

export default withRouter(OtpScreen);
